import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.css'
import { _Api } from '../../common/api/_call'
import '../custom.scss'
import CheckoutBlank from '../../checkout/checkoutBlank'
import 'rc-slider/assets/index.css'
import { DaimondSearchModal } from '../../common/module/daimondsearch'
import { useTranslation } from 'react-i18next'

const MixAndMatch = () => {
  const { t } = useTranslation()
  const { state } = useLocation()
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL
  const [items, setItem] = useState()
  const [ringProductPreview, setRingProductPreview] = useState(null)

  const getitem = async () => {
    try {
      const posdata = { type: 'mixAndMatch' }
      let res = await _Api(posdata, `api/v1/POS/home/itemList`)
      if (res.code === 200) {
        setItem(res?.data)
      } else {
        setItem([])
      }
    } catch (err) {
      console.log(err, 'err')
    }
  }
  useEffect(() => {
    getitem()
  }, [])

  /**
   * Product-first: dropdown / ring listing before picking a diamond.
   * Also detect returning when mixMatchFlow was dropped but product_id + items
   * are present (React Router/state edge cases).
   */
  const productFirstFlow =
    state?.mixMatchFlow === 'product_first' ||
    Boolean(
      !state?.daimond_id &&
        state?.product_id &&
        (state?.items?.id || state?.items?.name),
    )

  /**
   * Load ring image / SKU on the Mix & Match (diamond) page when product-first
   * and a product is already picked — enriched step strip (matches Figma).
   */
  useEffect(() => {
    if (!productFirstFlow || !state?.product_id) {
      setRingProductPreview(null)
      return undefined
    }
    let cancelled = false
    ;(async () => {
      try {
        const ic = state?.itemchanges
        const postdata = {
          product_id: state.product_id,
          Metal: ic?.metal,
          Size: ic?.size,
          Stone: ic?.stone,
          type:
            state?.optiondetailid || state?.filter?.Optiondetails
              ? 'catalog'
              : 'inventory',
        }
        const res = await _Api(
          postdata,
          `api/v1/POS/customOrder/mixAndMatch/getProductDetailById`,
        )
        if (cancelled || res?.code !== 200 || !res?.data) {
          return
        }
        const data = res.data
        const sel = data?.selected_data || {}
        const thumb =
          data?.main_image_Arr?.[0]?.image ||
          data?.main_image_Arr?.[0]?.thumb ||
          sel?.main_image ||
          sel?.image ||
          ''
        setRingProductPreview({
          name:
            sel?.name ||
            sel?.product_name ||
            data?.selected_data?.name ||
            data?.name ||
            data?.product_name ||
            sel?.item_name ||
            '',
          SKU:
            sel?.SKU ||
            sel?.sku ||
            data?.SKU ||
            data?.sku ||
            data?.selected_data?.SKU ||
            data?.selected_data?.sku ||
            '',
          image: thumb,
        })
      } catch (err) {
        console.log(err, 'mixAndMatch ring preview')
        if (!cancelled) setRingProductPreview(null)
      }
    })()
    return () => {
      cancelled = true
    }
  }, [
    state?.product_id,
    productFirstFlow,
    state?.mixMatchFlow,
    state?.daimond_id,
    state?.itemchanges,
    state?.optiondetailid,
  ])

  /**
   * Strip order + numbering:
   * • Diamond-first: Diamond Search (1) → Ring Search (2) → Place Complete (3).
   * • Product-first: Ring Search (1) → Diamond Search (2) → Place Complete (3).
   */
  const diamondStepNum = productFirstFlow ? 2 : 1
  const ringStepNum = productFirstFlow ? 1 : 2
  const diamondOrderClass = productFirstFlow ? 'order-2' : 'order-1'
  const ringOrderClass = productFirstFlow ? 'order-1' : 'order-2'
  const selectedItemTypeName = state?.items?.name
  const selectedTypeLogo =
    Array.isArray(items) && state?.items?.id
      ? items.find((it) => String(it?._id) === String(state?.items?.id))?.logo
      : null
  const ringCardEnriched = productFirstFlow && Boolean(state?.product_id)

  /** Keeps navigations aligned with diamond-first vs product-first step ordering. */
  const mixFlowForNav = productFirstFlow ? 'product_first' : 'diamond_first'

  const ringProductTitle =
    (ringProductPreview?.name || selectedItemTypeName || '')
      .trim() || t('Setting Selected')

  const ringSkuLine = (ringProductPreview?.SKU || '').trim()

  const optionDetailsBool =
    state?.filter?.Optiondetails !== undefined
      ? !!state.filter.Optiondetails
      : Boolean(state?.optiondetailid)

  const mixNavigateState = {
    daimond_id: state?.daimond_id ?? '',
    items: state?.items,
    product_id: state?.product_id,
    bychangeorder: state?.bychangeorder,
    optiondetailid: state?.optiondetailid,
    itemchanges: state?.itemchanges,
    mixMatchFlow: mixFlowForNav,
    editproduct: state?.editproduct,
    customcart: state?.customcart,
    scrvicelist: state?.scrvicelist,
    scrviceremark: state?.scrviceremark,
    remark: state?.remark,
    order_edit: state?.order_edit,
    order_id: state?.order_id,
    order_type: state?.order_type,
    mixmatchedit: state?.mixmatchedit,
    Engraving: state?.Engraving,
    showpage: state?.showpage,
  }

  const reviewDiamondSettingState = {
    product_id: state?.product_id,
    filter: {
      ...(typeof state?.filter === 'object' && state.filter ? state.filter : {}),
      Optiondetails: optionDetailsBool,
    },
    daimond_id: state?.daimond_id,
    items: state?.items,
    showpage: state?.showpage !== undefined ? state?.showpage : true,
    Engraving: state?.Engraving,
    editproduct: state?.editproduct,
    customcart: state?.customcart,
    scrvicelist: state?.scrvicelist,
    scrviceremark: state?.scrviceremark,
    remark: state?.remark,
    order_edit: state?.order_edit,
    order_id: state?.order_id,
    order_type: state?.order_type,
    mixmatchedit: state?.mixmatchedit,
    mixMatchFlow: mixFlowForNav,
  }

  /** Open ring / product picker from the strip (same flow whether diamond-first or product-first). */
  const ringSearchNavigateState = {
    daimond_id: state?.daimond_id ?? '',
    items: state?.items,
    product_id: '',
    filter: {
      ...(typeof state?.filter === 'object' && state.filter ? state.filter : {}),
      Optiondetails: optionDetailsBool,
    },
    bychangeorder: state?.bychangeorder,
    optiondetailid: state?.optiondetailid,
    itemchanges: undefined,
    mixMatchFlow: mixFlowForNav,
    editproduct: state?.editproduct,
    customcart: state?.customcart,
    scrvicelist: state?.scrvicelist,
    scrviceremark: state?.scrviceremark,
    remark: state?.remark,
    order_edit: state?.order_edit,
    order_id: state?.order_id,
    order_type: state?.order_type,
    mixmatchedit: state?.mixmatchedit,
    Engraving: state?.Engraving,
    showpage: state?.showpage,
  }

  const diamondStepCard = (
    <div
      className={`selection-step-card selection-step-card--searching ${diamondOrderClass} is-active`}
    >
      <span className="selection-step-card__num">{diamondStepNum}</span>
      <div className="selection-step-card__searching">
        <span className="selection-step-card__ring-icon" aria-hidden="true">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5 4.5H15L18 8.5L10 17.5L2 8.5L5 4.5Z"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinejoin="round"
              fill="none"
            />
            <path
              d="M5 4.5L7.25 8.5L10 17.5"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinejoin="round"
            />
            <path
              d="M15 4.5L12.75 8.5L10 17.5"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinejoin="round"
            />
            <path
              d="M2 8.5H18"
              stroke="currentColor"
              strokeWidth="1.2"
            />
          </svg>
        </span>
        <span className="selection-step-card__searching-label">
          {t('Diamond Search')}
        </span>
      </div>
    </div>
  )

  const ringThumbSrc =
    ringProductPreview?.image ||
    selectedTypeLogo ||
    base_assets + 'images/pos/steps/s1-g.png'

  const ringStepCard = (
    <div
      className={`selection-step-card ${ringOrderClass}${
        ringCardEnriched
          ? ' selection-step-card--mix-ring-enriched mix-match-step--ring-enriched-green'
          : ' selection-step-card--searching'
      }`}
    >
      <span className="selection-step-card__num">{ringStepNum}</span>
      {ringCardEnriched ? (
        <>
          <div className="selection-step-card__info">
            <div className="selection-step-card__title selection-step-card__title--ring-product">
              {ringProductTitle}
            </div>
            <div className="selection-step-card__bottom">
              {ringSkuLine ? (
                <span className="selection-step-card__sku mix-match-ring-step__sku-truncate">
                  {ringSkuLine}
                </span>
              ) : null}
              <div className="selection-step-card__actions">
                <Link
                  className="selection-step-card__link"
                  to="/app/pos/custom/mixdiamondsetting"
                  state={reviewDiamondSettingState}
                >
                  {t('Review')}
                </Link>
                <Link
                  className="selection-step-card__link"
                  to="/app/pos/custom/mixAndMatchProduct"
                  state={mixNavigateState}
                >
                  {t('Change')}
                </Link>
              </div>
            </div>
          </div>
          <div className="selection-step-card__thumb">
            <img
              src={ringThumbSrc}
              alt=""
              onError={(e) => {
                e.currentTarget.onerror = null
                e.currentTarget.src =
                  base_assets + 'images/pos/steps/s1-g.png'
              }}
            />
          </div>
        </>
      ) : (
        <Link
          className="selection-step-card__searching text-decoration-none"
          to="/app/pos/custom/mixAndMatchProduct"
          state={ringSearchNavigateState}
          style={{ color: 'inherit' }}
        >
          <span className="selection-step-card__ring-icon" aria-hidden="true">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <ellipse
                cx="10"
                cy="13.25"
                rx="5.25"
                ry="3"
                stroke="currentColor"
                strokeWidth="1.4"
                fill="none"
              />
              <path
                d="M10 3.25L12.4 7L10 8.75L7.6 7L10 3.25Z"
                fill="currentColor"
              />
            </svg>
          </span>
          <span className="selection-step-card__searching-label">
            {t('Ring Search')}
          </span>
        </Link>
      )}
    </div>
  )

  return (
    <>
      <div className="main-body">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="catalog-area bg-white page-menu-block">
              <div className="common-navigation-header">
                <div className="common-navigation-header-left">
                  <h3 className="common-navigation-header-left-heading">
                    {' '}
                    <Link
                      to="/app/pos/custom/custom"
                      className="gray-mid text-decoration-none"
                    >
                      {t('CUSTOM ORDER')}{' '}
                    </Link>
                    <img
                      className="Dailysalereport-head-arrow mx-3"
                      src={base_assets + 'images/pos/report/arrow-right.png'}
                      alt=""
                    />{' '}
                    {t('Mix and Match')}
                  </h3>
                </div>
              </div>
              <div
                className={`selection-process large-selection-process mix-match-selection-process${
                  productFirstFlow ? ' mix-match-strip--product-first' : ''
                }`}
              >
                {false && (
                  <div className="mix-match-dropdown-row">
                    <div className="dropdown common-dropdown diamond-dropdown">
                      <button
                        className="btn btn-secondary dropdown-toggle"
                        type="button"
                        id="dropdownDiamond"
                        data-bs-toggle="dropdown"
                        data-bs-display="static"
                        aria-expanded="false"
                        aria-haspopup="true"
                      >
                        <span>
                          <img
                            src={
                              base_assets +
                              'images/pos/icons/diamond-icon-green.png'
                            }
                            alt=""
                          />
                        </span>{' '}
                        <span className="mix-match-dropdown-toggle-label">
                          {t('Diamond')}
                        </span>
                      </button>
                      <ul
                        className="dropdown-menu dropdown-menu-end mix-match-item-menu"
                        aria-labelledby="dropdownDiamond"
                      >
                        {items?.length ? (
                          items.map((result, itkey) => (
                            <li key={itkey}>
                              <Link
                                className="dropdown-item"
                                to="/app/pos/custom/mixAndMatchProduct"
                                state={{
                                  daimond_id: '',
                                  items: {
                                    id: result?._id,
                                    name: result?.name,
                                  },
                                  editproduct: state?.editproduct,
                                  customcart: state?.customcart,
                                  scrvicelist: state?.scrvicelist,
                                  scrviceremark: state?.scrviceremark,
                                  remark: state?.remark,
                                  mixMatchFlow: 'product_first',
                                }}
                              >
                                <span className="mix-match-dropdown-item-thumb">
                                  <img
                                    src={result?.logo ? result?.logo : ''}
                                    alt=""
                                  />
                                </span>
                                <span className="mix-match-dropdown-item-text">
                                  {result?.name}
                                </span>
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li>
                            <span className="dropdown-item disabled">
                              {t('No items')}
                            </span>
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                )}
                <div className="mix-match-steps-row">
                  {diamondStepCard}
                  {ringStepCard}
                  {/* Step 3: Place Complete (inactive) */}
                  <div className="selection-step-card selection-step-card--complete order-3">
                    <span className="selection-step-card__num">3</span>
                    <div className="selection-step-card__searching">
                      <svg
                        className="selection-step-card__check"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <circle
                          cx="10"
                          cy="10"
                          r="8.25"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        />
                        <path
                          d="M6.75 10.25L9.25 12.75L13.5 8"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <span className="selection-step-card__searching-label">
                        {t('Place Complete')}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <DaimondSearchModal
                mixMatchFlow={
                  productFirstFlow ? 'product_first' : 'diamond_first'
                }
              />
            </div>
          </div>
          <div className="main-body-row-right-col">
            <CheckoutBlank />
          </div>
        </div>
      </div>
    </>
  )
}

export default MixAndMatch
